import { call, put, select, takeLatest } from 'redux-saga/effects';

import { request } from '!core/api';
import { menusSlice } from '»components/Menus';
import { handleSagaError } from '»utils/handleSagasError';
import { navigate } from '»utils/navigation';

import { loginIdSelector, selectUserId } from '../redux';
import { logoutSlice } from './_logout.slice';
import { logoutServices } from './logout.services';

const logoutWoker = function* ({ payload }) {
  try {
    navigate('/');
    const username = yield select(selectUserId);
    const loginId = yield select(loginIdSelector);
    yield call(logoutServices.logout, { username, loginId });
    yield call(request.clearHeaders);
    yield put(
      logoutSlice.actions.logoutSuccess({ showAlert: payload.showAlert }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) {
      navigate('/');
      yield put(
        menusSlice.actions.setActiveMenuItem({
          activeMenuItem: 'LANDING_PAGE',
        }),
      );
      yield call(request.clearHeaders);
      yield put(logoutSlice.actions.logoutFailure());
    }
  }
};

export const logoutSagas = function* () {
  yield takeLatest(logoutSlice.actions.logoutRequest.type, logoutWoker);
};
